import { HttpTypes } from "@medusajs/types"
import { FrontendLocale } from "@lib/frontend-preferences"

type ProductContentOverride = {
  fa: {
    title: string
    description: string
  }
}

const productContentOverrides: Record<string, ProductContentOverride> = {
  "medusa-t-shirt": {
    fa: {
      title: "تی‌شرت مدوسا",
      description:
        "احساس یک تی‌شرت کلاسیک را دوباره تصور کنید. با تی‌شرت‌های نخی ما، ضروریات روزمره دیگر معمولی نیستند.",
    },
  },
  "medusa-sweatshirt": {
    fa: {
      title: "سویشرت مدوسا",
      description:
        "یک لایهٔ نرم و همه‌کاره برای روزهای آرام؛ طراحی‌شده برای راحتی روزمره.",
    },
  },
  "medusa-sweatpants": {
    fa: {
      title: "شلوار اسلش مدوسا",
      description:
        "راحتی روزمره با فرمی ساده و نرم؛ مناسب برای خانه و بیرون از خانه.",
    },
  },
  "medusa-shorts": {
    fa: {
      title: "شلوارک مدوسا",
      description:
        "شلوارکی سبک و راحت برای روزهای گرم و حرکت آزاد.",
    },
  },
  "medusa-tote-bag": {
    fa: {
      title: "کیف پارچه‌ای مدوسا",
      description:
        "یک کیف پارچه‌ای سبک و کاربردی برای همراه داشتن انتخاب‌های روزانه.",
    },
  },
}

const normalizeProductKey = (value?: string | null) =>
  value
    ?.trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")

const taxonomyContentOverrides: Record<string, string> = {
  "silk-edit": "منتخب ابریشم",
  "cotton-stories": "داستان‌های پنبه",
  "paisley-notes": "نقش‌های بته‌جقه",
  "evening-tides": "موج‌های شبانه",
  "limited-edit": "منتخب محدود",
  resort: "مجموعه ساحلی",
  "resort-collection": "مجموعه ساحلی",
}

export const getLocalizedTaxonomyTitle = (
  value: string,
  locale: FrontendLocale
) => {
  if (locale === "en") return value

  return taxonomyContentOverrides[normalizeProductKey(value) || ""] || value
}

export const getLocalizedProductContent = (
  product: Pick<HttpTypes.StoreProduct, "handle" | "title" | "description">,
  locale: FrontendLocale
) => {
  if (locale === "en") {
    return {
      title: product.title,
      description: product.description,
    }
  }

  const keys = [
    normalizeProductKey(product.handle),
    normalizeProductKey(product.title),
  ].filter((key): key is string => Boolean(key))

  const override = keys
    .map((key) => productContentOverrides[key])
    .find(Boolean)

  return {
    title: override?.fa.title ?? product.title,
    description: override?.fa.description ?? product.description,
  }
}
